import { useEffect } from "react";

import { useRouter } from "next/router";

import { ContainerLoader } from "@/components/Loaders/ContainerLoader";
import { AmplitudeEvents } from "@/constants/amplitude";
import { useIsUnsupportedBrowserForDashboard } from "@/features/UnsupportedBrowser/useIsUnsupportedBrowser";
import { getFromLocalStorage } from "@/helpers/localStorage";
import { useAmplitude } from "@/hooks/amplitude/useAmplitude";

export const RedirectOnUnsupportedDashboardBrowser = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  const { logAmplitudeEvent } = useAmplitude();

  const bypassed = getFromLocalStorage?.("bypassDashboardUnsupportedBrowser");
  const isUnsupportedBrowser = useIsUnsupportedBrowserForDashboard();

  const shouldRedirect = isUnsupportedBrowser && bypassed !== "true" && router.isReady;

  useEffect(() => {
    if (shouldRedirect) {
      router.replace(
        `/unsupported-browser?source=dashboard&returnUrl=${encodeURIComponent(window.location.href)}`,
        undefined,
        {
          shallow: true,
        }
      );
    }
  }, [router, shouldRedirect]);

  useEffect(() => {
    // Send an event to Amplitude if a user would have been redirected to the unsupported browser page
    if (isUnsupportedBrowser) {
      logAmplitudeEvent(AmplitudeEvents.UnsupportedBrowserRedirection, {
        source: "dashboard",
      });
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (shouldRedirect) {
    return <ContainerLoader fullPage />;
  }

  return <>{children}</>;
};
